export const SIGNALR_EVENTS = {
  APPROVAL_REQUESTED: 'ApprovalRequested',
  APPROVAL_DECISION:  'ApprovalDecision',
  APPROVAL_WITHDRAWN: 'ApprovalWithdrawn',
  APPROVAL_RESOLVED:  'ApprovalResolved',   // another approver decided: sent to the approvers who did not
  FORCE_LOGOUT:       'ForceLogout',
};

// Not a hub message: signalRService fires it on `window` after a reconnect or when a long-hidden tab returns, so the
// owners of live data (ApprovalContext) refetch what a push may have missed. SignalR does not replay missed messages.
export const SIGNALR_RESYNC_EVENT = 'tifoxr-signalr-resync';
